/**
 * 侧边栏菜单配置
 * @author jasonelchen
 */
import React from 'react'
import { MenuItem } from '@components'
import { moduleId } from '@configs/index'
import {
  DesktopOutlined,
  CarryOutOutlined,
  SolutionOutlined,
  BookOutlined, HomeOutlined, LineChartOutlined, SettingOutlined,
} from '@ant-design/icons'

const routes: MenuItem[] = [
  {
    key: 'index',
    title: '首页',
    url: '/',
    Icon: <HomeOutlined />,
  },
  {
    key: 'performance',
    title: '业绩概览',
    url: '/performance',
    Icon: <LineChartOutlined />,
    authPoints: ['menuPerformance'],
  },
  {
    key: 'kanban',
    title: '数据看板',
    url: '/kanban',
    Icon: <LineChartOutlined />,
    authPoints: ['menuReportKanban'],
    belongModule: [moduleId.MID_LONG_TAIL_ID],
  },
  {
    key: 'kanban-admin',
    title: '管理看板',
    url: '/kanban-admin',
    Icon: <LineChartOutlined />,
    authPoints: ['menuReportKanbanAdmin'],
    belongModule: [moduleId.MID_LONG_TAIL_ID],
  },
  {
    key: 'task',
    title: '任务管理',
    Icon: <DesktopOutlined />,
    subMenus: [
      // {
      //   key: 'task.list',
      //   title: '座席工作台',
      //   url: '/task/list',
      //   Icon: <DesktopOutlined />,
      //   authPoints: ['menuTaskList'],
      // },
      {
        key: 'task.workspace',
        title: '座席工作台',
        url: '/task/workspace',
        authPoints: ['menuTaskList'],
      },
      {
        key: 'task.goal',
        title: '目标管理',
        url: '/task/goal',
        authPoints: ['menuTaskGoal'],
      },
      {
        key: 'task.all.task',
        title: '所有任务',
        url: '/task/all-task',
        authPoints: ['menuTaskAllTask'],
      },
      {
        key: 'task.follow.record',
        title: '跟进记录',
        url: '/task/follow-record',
        authPoints: ['menuTaskFollowRecord'],
      },
      {
        key: 'task.follow.record-sdr',
        title: '跟进记录',
        url: '/task/follow-record-sdr',
        authPoints: ['menuTaskFollowRecordSdr'],
        belongModule: [moduleId.SDR_CLEAN],
      },
      {
        key: 'task.quality.inspection',
        title: '质检方案',
        url: '/task/quality-inspection',
        authPoints: ['menuTaskCallEvaluateR', 'menuTaskCallKeyWordsR', 'menuTaskCallEvaluateU'],
      },
      {
        key: 'task.quality.check.reexamine.list',
        title: '人工复核',
        url: '/task/quality-check/reexamine-list',
        authPoints: ['menuTaskCallReexamineList'],
      },
      {
        key: 'task.call.record',
        title: '通话记录',
        url: '/task/call-record',
        authPoints: ['menuTaskCallRecord'],
      },
      {
        key: 'task.call.robot',
        title: '机器人通话记录',
        url: '/task/robot-call-record',
        authPoints: ['menuRobotCallRecord'],
      },
      {
        key: 'task.call.meeting',
        title: '腾讯会议记录',
        url: '/task/meeting-record',
        authPoints: ['menuMeetingRecord'],
        // 临时增加，控制菜单是否可以被用户灰度逻辑控制
        grayboxPoint: ['useMeeting'],
      },
      {
        key: 'task.sms.record',
        title: '短信记录',
        url: '/task/sms-record',
        authPoints: ['menuTaskSmsRecord'],
      },
      {
        key: 'task.retain.record',
        title: '留资记录',
        url: '/task/retain-record',
        authPoints: ['menuTaskRetainRecord'],
      },
    ],
  },
  {
    key: 'lead',
    title: '线索管理',
    Icon: <CarryOutOutlined />,
    subMenus: [
      {
        key: 'lead.hotline',
        title: '400热线接待',
        url: '/lead/hotline',
        authPoints: ['menuLeadHotline'],
        belongModule: [moduleId.MID_LONG_TAIL_CLEAN_ID],
      },
      {
        key: 'lead.list.claimed',
        title: '已派发线索',
        url: '/lead/list/claimed',
        authPoints: ['menuLeadListClaimed'],
      },
      {
        key: 'lead.list.unclaimed',
        title: '线索公海池',
        url: '/lead/list/unclaimed',
        authPoints: ['menuLeadListUnclaimed'],
      },
      {
        key: 'lead.list.discard',
        title: '废弃线索池',
        url: '/lead/list/discard',
        authPoints: ['menuLeadListDiscard'],
      },
      {
        key: 'lead.list.intention',
        title: '意向线索',
        url: '/lead/list/intention',
        authPoints: ['menuLeadListIntention'],
        belongModule: [moduleId.SDR_CLEAN],
      },
      {
        key: 'lead.list.pipeline',
        title: '待孵化线索',
        url: '/lead/list/pipeline',
        authPoints: ['menuLeadListPipeline'],
        belongModule: [moduleId.SDR_CLEAN],
      },
      {
        key: 'lead.list.recall',
        title: '待复呼线索',
        url: '/lead/list/recall',
        authPoints: ['menuLeadListRecall'],
        belongModule: [moduleId.SDR_CLEAN],
      },
      {
        key: 'lead.list.transfer',
        title: '待转出意向线索',
        url: '/lead/list/transfer',
        authPoints: ['menuLeadListTransfer'],
        belongModule: [moduleId.SDR_CLEAN],
      },
      {
        key: 'lead.add',
        title: '上传线索',
        url: '/lead/add',
        authPoints: ['menuLeadAdd'],
      },
      {
        key: 'lead.add-sdr',
        title: '上传企微孵化线索',
        url: '/lead/add-sdr',
        authPoints: ['menuLeadAddSdr'],
        belongModule: [moduleId.SDR_CLEAN],
      },
      {
        key: 'lead.circulate.record',
        title: '线索流转记录',
        url: '/lead/circulate-record',
        authPoints: ['menuLeadCirculateRecord'],
      },
    ],
  },
  {
    key: 'customer',
    title: '客户管理',
    Icon: <SolutionOutlined />,
    subMenus: [
      {
        key: 'customer.opportunity',
        title: '商机列表',
        url: '/customers/opportunity',
        authPoints: ['menuCustomerOpportunity'],
      },
      {
        key: 'customer.resource',
        title: '客户资源池',
        url: '/customers/resource',
        authPoints: ['menuCustomerResource'],
      },
      {
        key: 'customer.pure',
        title: '公海池',
        url: '/customers/pure-pool',
        authPoints: ['menuCustomerPurePool'],
      },
      {
        key: 'customer.company.pool',
        title: '公司私海池',
        url: '/customers/company-pool',
        authPoints: ['menuCustomerCompanyPool'],
      },
      {
        key: 'customer.investigate',
        title: '考察客户池',
        url: '/customers/investigate',
        authPoints: ['menuCustomerInvestigate'],
        belongModule: [moduleId.MID_LONG_TAIL_ID],
      },
      {
        key: 'customer.linked',
        title: '关联客户池',
        url: '/customers/linked',
        authPoints: ['menuCustomerLinked'],
        belongModule: [moduleId.MID_LONG_TAIL_ID],
      },
      {
        key: 'customer.saas.config',
        title: 'SaaS产品配置单',
        url: '/customers/saas-config',
        authPoints: ['menuSaasConfig'],
      },
      {
        key: 'customer.transfer',
        title: '转出客户池',
        url: '/customers/transfer',
        authPoints: ['menuCustomerTransfer'],
      },
      {
        key: 'customer.trans.temp',
        title: '回流临时池',
        url: '/customers/trans-temp',
        authPoints: ['menuCustomerTransTemp'],
        belongModule: [moduleId.MID_LONG_TAIL_ID],
      },
      {
        key: 'customer.scrm.flow.log',
        title: '私域关联流程记录',
        url: '/customers/scrm-flow-log',
        authPoints: ['menuCustomerFlowLog'],
        // authPoints: ['menuCustomerLinkLog'],
      },
      {
        key: 'customer.link.log',
        title: '专属链接关联记录',
        url: '/customers/link-log',
        authPoints: ['menuCustomerLinkLog'],
      },
      {
        key: 'customer.link.release.list',
        title: '释放保护期记录',
        url: '/customers/release-list',
        authPoints: ['menuCustomerReleaselist'],
        belongModule: [moduleId.MID_LONG_TAIL_ID, moduleId.SASS_ID, moduleId.COC_TURN_ID],
      },
      {
        key: 'customer.order.detail',
        title: '订单明细',
        url: '/customers/order-detail',
        authPoints: ['menuCustomerOrderDetail'],
      },
      {
        key: 'customer.assign.record',
        title: '客户变更记录',
        url: '/customers/assign-record',
        authPoints: ['menuCustomerAssignRecord'],
      },
      {
        key: 'customer.conflict.record',
        title: '撞单分配记录',
        url: '/customers/conflict-record',
        authPoints: ['menuCustomerConflictRecord'],
      },
      {
        key: 'customer.bind-failure',
        title: '指派失败记录',
        url: '/customers/bind-failure',
        authPoints: ['menuBindFailure'],
        belongModule: [moduleId.REBATE_ID],
      },
      {
        key: 'customer.unbind',
        title: '解绑客户记录',
        url: '/customers/unbind',
        authPoints: ['menuUnbind'],
        belongModule: [moduleId.REBATE_ID],
      },
    ],
  },
  {
    key: 'config',
    Icon: <SettingOutlined />,
    title: '配置管理',
    subMenus: [
      {
        key: 'config.my.apply',
        title: '我的申请',
        url: '/config/my-apply',
      },
      {
        key: 'config.tccc',
        title: '外呼服务接入配置',
        url: '/config/tccc',
        authPoints: ['menuConfigTCCC'],
      },
      {
        key: 'config.organization',
        title: '组织架构管理',
        url: '/config/organization',
        authPoints: ['menuConfigOrganization'],
      },
      {
        key: 'config.knowledge.upload',
        title: '知识库上传',
        url: '/config/knowledge-upload',
        authPoints: ['menuConfigKnowledgeUpload'],
      },
      {
        key: 'config.tags',
        title: '标签管理',
        url: '/config/tags',
        authPoints: ['menuConfigTags'],
      },
      {
        key: 'config.rule.type',
        title: '规则分类管理',
        url: '/config/rule-type',
        authPoints: ['menuConfigRuleType'],
      },
      {
        key: 'config.sms',
        title: '消息模版管理',
        url: '/config/sms',
        authPoints: ['menuConfigSms'],
      },
      {
        key: 'config.lead.rule',
        title: '自动处理规则',
        url: '/config/lead-rule',
        authPoints: ['menuConfigLeadRule'],
      },
      {
        key: 'config.follow',
        title: '跟进表单管理',
        url: '/config/follow',
        authPoints: ['menuConfigFollow', 'menuConfigFollowSdr'],
      },
      {
        key: 'config.task.log',
        title: '系统任务列表',
        url: '/config/task-log',
        authPoints: ['menuConfigTaskLog'],
      },
      {
        key: 'config.quality.check.scheme',
        title: '质检方案配置',
        url: '/config/quality-check-scheme',
        authPoints: ['menuConfigQualityCheckScheme'],
      },
      {
        key: 'config.quality.check.management',
        title: '质检任务管理',
        url: '/config/quality-check-management',
        authPoints: ['menuConfigQualityCheckTask'],
      },
      {
        key: 'config.task.robot',
        title: '机器人名单',
        url: '/config/robot-task-log',
        authPoints: ['menuRobotTask'],
      },
      {
        key: 'config.llm.tuning',
        title: '大模型调试',
        url: '/config/llm-tuning',
        authPoints: ['menuConfigLlmTuning'],
      },
      {
        key: 'config.retain.resource.list',
        title: '留资表单管理',
        url: '/config/retain-resource-list',
        authPoints: ['menuConfigRetainResourceList'],
      },
      {
        key: 'config.batch.info',
        title: '批次信息',
        url: '/config/batch-info',
        authPoints: ['menuConfigBatchInfo'],
      },
      {
        key: 'config.operation.Log',
        title: '操作日志',
        url: '/config/operation-Log',
        authPoints: ['menuConfigOperationLog'],
      },
    ],
  },
  {
    key: 'report',
    title: '统计报表',
    Icon: <BookOutlined />,
    subMenus: [
      {
        key: 'report.agent.task',
        title: '坐席日常任务明细',
        url: '/report/agent-task',
        authPoints: ['menuReportAgentTask'],
      },
    ],
  },
]
export default routes
